import * as R from 'ramda'

export const getRedirectURL = (lang, target) => `/${R.path(['lang'], lang)}/${R.path(['db'], lang)}${target}`
